export const ANALYTICS_TAB_CLICK="tab_click";
export const HOME_CLICK="home_home_click";
export const DEFECTS_CLICK="defects_defects_click";
export const GRADE_CLICK="grade_idwal_grade_click";
export const SUB_GRADE_CLICK="sub_grade_sub_grade_click";
export const REPORTS_CLICK="reports_click";
export const ORDERS_CLICK = "orders_click";
export const QUOTATIONS_CLICK = "quotations_click";
export const QUOTATION_CLICK = "quotation_click";
export const QUOTATIONS_ACTION_CLICK = "quotations_action_click"
export const REPORTS_ACTION_CLICK = "reports_action_click"
export const ORDERS_ACTION_CLICK = "orders_action_click"
export const VIEW_REPORT_CLICK = "view_report_click"
export const DOWNLOAD_ORDER_CONFIRMATION_CLICK = "download_order_confirmation_click"
export const OPEN_QUOTATION_MODAL = "open_quotation";
export const CLOSE_QUOTATION_MODAL = "close_quotation";
export const CREATE_QUOTATION = "create_quotation";
export const DELETE_QUOTATION = "delete_quotation";
export const EDIT_QUOTATION = "edit_quotation";
export const VIEW_QUOTATION = "view_quotation";
export const DOWNLOAD_QUOTATION = "download_quotation";
export const ORDER_INSPECTION = "order_inspection";
export const ADD_QUOTATION_EXTRA_CLICK = "add_quotation_extra_click";
export const REMOVE_QUOTATION_EXTRA_CLICK = "remove_quotation_extra_click";
export const SCREENING="screening";
export const SCREENING_CLICK="screening_click";